import { useState, useEffect } from 'react';
import { createApiClient } from '../../../services/ApiClient.jsx';

export const useSubmissionHistory = (accessToken, formId) => {
    const [history, setHistory] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const apiClient = createApiClient(accessToken);

    const fetchHistory = async () => {
        if (!formId || !accessToken) {
            console.log('⚠️ Cannot fetch history - missing formId or accessToken:', { formId: !!formId, accessToken: !!accessToken });
            return;
        }

        try {
            setLoading(true);
            setError(null);
            console.log('🔍 Attempting to fetch submission history for form:', formId);
            console.log('🔍 Access token format check:', {
                hasToken: !!accessToken,
                tokenType: typeof accessToken,
                tokenLength: accessToken?.length,
                startsWithBearer: accessToken?.startsWith?.('Bearer'),
                isString: typeof accessToken === 'string'
            });
            const response = await apiClient.get(`/api/submissions/history/${formId}`);
            console.log('✅ Submission history response:', response);
            setHistory(response);
        } catch (err) {
            console.error('❌ Error fetching submission history:', err);
            console.error('❌ Error details:', {
                message: err.message,
                status: err.response?.status,
                statusText: err.response?.statusText,
                data: err.response?.data
            });
            // Set a more graceful error that doesn't break the component
            setError('Submission history temporarily unavailable');
            // Set empty history instead of null to prevent component issues
            setHistory({ submissions: [], total_attempts: 0 });
        } finally {
            setLoading(false);
        }
    };

    const fetchDetailedSubmission = async (submissionId) => {
        try {
            const response = await apiClient.get(`/api/submissions/detailed/${submissionId}`);
            return response;
        } catch (err) {
            console.error('Error fetching detailed submission:', err);
            throw err;
        }
    };

    // Don't auto-fetch history on mount to avoid CORS errors
    // History will be fetched only when explicitly requested
    // useEffect(() => {
    //     fetchHistory();
    // }, [formId, accessToken]);

    return {
        history,
        loading,
        error,
        fetchHistory,
        fetchDetailedSubmission
    };
};
